import { Navigate, Outlet } from "react-router-dom";
import { usesInspectionWorkspace } from "./access.js";

export function InspectionAccessRoute({ currentUser }) {
  if (!usesInspectionWorkspace(currentUser)) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
